import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-sign-up-form',
  templateUrl: './sign-up-form.component.html',
  styleUrls: ['./sign-up-form.component.scss']
})
export class SignUpFormComponent implements OnInit {

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  form: FormGroup;
  
  @Input()
  processing: FormGroup;

  userAgree = false;
  constructor() { }

  ngOnInit(): void {}

  getControl(name) {
    return this.form.get(name);
  }

  next() {
    this.submit.emit();
  }

}

